import { ScriptureReader } from './components/ScriptureReader';
import './index.css';

function App() {
  return (
    <div className="App">
      <ScriptureReader />
    </div>
  );
}

export default App;
